import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=43118370"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports